'use strict';

const scrollTo = (element, to, duration) => {
    if (duration <= 0) return;

    const difference = to - element.scrollTop;
    const perTick = difference / duration * 10;

    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    }, 10);
};

export function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}

export function getPosition(el) {
  let xPos = 0;
  let yPos = 0;

  while (el) {
    if (el.tagName == "BODY") {
      // deal with browser quirks with body/window/document and page scroll
      let xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      let yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += (el.offsetLeft - xScroll + el.clientLeft);
      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent;
  }
  return {
    x: xPos,
    y: yPos
  };
}

export function scrollDocumentTo(to, duration) {
    // console.log(to, duration);
    scrollTo(document.body, to, duration);
}

export function forEachEl(els, callback) {
    const elCount = els.length;
    let i, boundCallback;

    for (i = 0; i < elCount; i++) {
        callback(els[i], i);
    }
}

export function hasClass(el, klass) {
    if (el.classList) {
        return el.classList.contains(klass);
    }

    return new RegExp('(^| )' + klass + '( |$)', 'gi').test(el.className);
}

export function addClass(el, klass) {
    if (el.classList) {
        return el.classList.add(klass);
    }

    return el.className += ' ' + klass;
}

export function removeClass(el, klass) {
    if (el.classList) {
        return el.classList.remove(klass);
    }

    return el.className = el.className.replace(new RegExp('(^|\\b)' + klass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

export function findTarget(el, klass) {
    if (hasClass(el, klass)) { return el; }
    return parents(el, klass);
}

export function parents(el, klass) {
    if (!el) { return null; }

    let found = false;
    let targetEl = null;
    let parentEl = el.parentNode;

    let index = 0;

    while (targetEl === null) {
        index++;
        if (index > 3000) { break; }
        if (!parentEl) { break; }

        if (parentEl.tagName === 'BODY' && !hasClass(parentEl, klass)) { break; }

        if (!hasClass(parentEl, klass)) {
            parentEl = parentEl.parentNode;
            continue;
        }

        targetEl = parentEl;
    }

    return targetEl;
}

export function cumulativeOffset(element) {
    var top = 0, left = 0;
    do {
        top += element.offsetTop  || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while(element);

    return {
        top: top,
        left: left
    };
};

export function all(selector) {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
}

export function one(selector) {
    return document.querySelector(selector);
}
